import React, { useState, useEffect } from "react";
import { Modal, Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";
import AngelaIconMultiR1C from "../Common/Angela/AngelaIconMultiR1C";
import ZenVerBarChart from "../Common/Graph/ZenVerBarChart";
import ZenGaugeMultiColor from "../Common/Graph/ZenGaugeMultiColor";
import ZenModal from "../../ZenModal";
import { createRoute } from "../../../utils/CustomFunc";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

// Houdini_ImportData

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

const YiplCorpDashboardLatest = ({
    setPageHeader
}) => {
    const urlCode = useSelector(state => state.urlCode);
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const [mainDataList, setMainDataList] = useState();
    const [zenModalData, setZenModalData] = useState();
    const [loading, setLoading] = useState(true);
    const [loginError, setLoginError] = useState(false);
    const [intervalTime, setIntervalTime] = useState();
    const [modal, setModal] = useState({
        type: "route",
        data: undefined,
        show: false,
        loading: false,
    });

    const toggleModal = ({
        show = false,
        data = undefined,
        type = '',
        loading = false,
    }) => {
        setModal({ show, data, type, loading });
    };
    const fetchChartData = () => {
        liracrypt
            .get("/yiplcorp/dashboard", {
                ...searchParams,
                lid: 'all',
                mnt: 'all',
                typ: "MainGraph",
                corpPlantCode: "YIPL_CORP",
                subTyp: 'all',
                chartGroup: "YiplCorpDashboard01",
            })
            .then(({ data }) => {
                if (data.isSuccess) {
                    if (setPageHeader) {
                        setPageHeader(data.config?.pageTitle || 'YIPL Plant Status');
                    }
                    setMainDataList(data.data);
                    setIntervalTime(data.config?.dataRefreshInterval);
                    setLoading(false);
                }
            })
            .catch(error => {
                console.log(error);
                if (error.response !== undefined) {
                    if (error.response.status !== 401) {
                        ApiErrorComp(error.response.status);
                    } else {
                        setLoginError(true);
                    }
                }
            })
    };

    useEffect(() => {
        setLoading(true);
        fetchChartData();
    }, [search]);

    useEffect(() => {
        let interval;
        if (intervalTime) {
            interval = setInterval(() => {
                fetchChartData();
            }, intervalTime);
        };
        return () => clearInterval(interval);
    }, [intervalTime]);

    const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
        if (popData.method === 'GET') {
            liracrypt.get(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'POST') {
            liracrypt.post(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    resolve();
                }).catch(err => {
                    console.log(err);
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'PATCH') {
            liracrypt.patch(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
    }


    const onColumnClick = (zenModal, record) => {
        if (!zenModal) {
            return
        };
        setZenModalData(zenModal);
        let urlData = { ...zenModal?.params, ...searchParams };
        if (zenModal?.multiProps) {
            zenModal?.multiProps.forEach((prop) => {
                urlData[prop] = record[prop];
            });
        };
        if (zenModal?.props) {
            urlData[zenModal?.props] = record[zenModal?.props];
        };
        if (zenModal?.typ === 'confirmationPopUp') {
            let urlData = { ...zenModal?.onOk?.params };
            if (zenModal?.onOk?.multiProps) {
                zenModal?.onOk?.multiProps.forEach((prop) => {
                    urlData[prop] = record[prop];
                });
            };
            if (zenModal?.onOk?.props) {
                urlData[zenModal?.onOk?.props] = record[zenModal?.onOk?.props];
            }

            Modal.confirm({
                title: zenModal?.text,
                okText: zenModal?.okButtonText,
                cancelText: zenModal?.cancelButtonText,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        onConfirmation({
                            popData: zenModal?.onOk,
                            resolve,
                            reject,
                            urlData
                        });
                    }).catch(() => console.log('Oops errors!'));
                }
            });
            return;
        }
        if (zenModal?.typ === 'newTab') {
            let zenParams = { ...urlData };
            if (zenModal?.api) {
                zenParams.api = zenModal?.api;
            };
            let route = createRoute({
                props: zenModal?.props,
                record,
                multiProps: zenModal?.multiProps,
                params: { ...zenParams },
                urlCode,
                route: zenModal?.urlType === 'dynamic' ? record[zenModal?.urlKey] : zenModal?.route
            });
            window.open(route, '_blank')
            return;
        };
        if (zenModal?.typ === "smodal") {
            toggleModal({
                loading: false,
                type: 'smodal',
                show: true,
                data: { ...urlData, ...searchParams },
            });
            return;
        }
        if (zenModal?.typ === "route") {
            toggleModal({
                loading: false,
                type: 'route',
                show: true,
                data: {
                    route: zenModal?.route,
                    urlData,
                },
            });
            return;
        }
        if (zenModal?.api) {
            toggleModal({ show: true, loading: true });
            liracrypt
                .get(`${zenModal?.api}`, urlData)
                .then((response) => {
                    toggleModal({
                        show: true,
                        data: response?.data?.data,
                        loading: false,
                        type: zenModal.typ
                    });
                });
            return;
        }
    };

    return (
        <>
            <SessionError visible={loginError} />
            <div
                style={{
                    background: "#000000",
                    paddingTop: 10,
                    //   backgroundImage:
                    //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
                }}
            >
                {loading === false ? (
                    <div>
                        <ZenModal
                            modal={modal}
                            toggleModal={toggleModal}
                            //smodalCallback={props.api ? getApiChartData : props.smodalCallback}
                            zenModal={zenModalData}
                        />
                        <Row style={{ background: "#000000" }}>
                            {
                                mainDataList.map((chart, index) => (
                                    <Col span={8}>
                                        <div
                                            style={{
                                                borderRadius: "10px",
                                                // background: "#191C24",
                                                border: "1px solid #3c3e4f",
                                                margin: 10
                                            }}
                                        >
                                            <Row >
                                                <Col span={6}>
                                                    <div
                                                        style={{
                                                            margin: "0px",
                                                            padding: "0px",
                                                        }}
                                                    >
                                                        <div
                                                            onClick={() => onColumnClick(chart.title.zenPop, chart.title)}
                                                            style={{
                                                                ...chart.title.style,
                                                                cursor: chart.title.zenPop ? 'pointer': undefined
                                                            }}
                                                        >
                                                            {chart.title.text}
                                                        </div>

                                                        {/* ____________________________________START __________FORMAT________________TEMPLATE___________________*/}

                                                        {/* _______Row No 4________ */}
                                                        <Row >
                                                            <Col style={{ width: "97%" }}>
                                                                <div
                                                                    style={{
                                                                        borderRadius: "10px",
                                                                        background: "#191C24",
                                                                        border: "1px solid #3c3e4f",
                                                                        margin: "2px 2px 2px 2px",
                                                                    }}
                                                                >
                                                                    <ZenGaugeMultiColor
                                                                        divId={`Dle-${index}`}
                                                                        data={chart.Dle.data}
                                                                        config={chart.Dle.config}
                                                                        onChange={(data) => { }
                                                                        }
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        {/* _______Row No 5________ */}
                                                        <Row >
                                                            <Col style={{ width: "97%" }}>
                                                                <div
                                                                    style={{
                                                                        borderRadius: "10px",
                                                                        background: "#191C24",
                                                                        border: "1px solid #3c3e4f",
                                                                        margin: "2px 2px 2px 2px",
                                                                    }}
                                                                >
                                                                    <ZenGaugeMultiColor
                                                                        divId={`Productivity-${index}`}
                                                                        data={chart.Productivity.data}
                                                                        config={chart.Productivity.config}
                                                                        onChange={(data) => { }
                                                                        }
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        {/* _______Row No 6________ */}

                                                        {/* Houdini_DivData */}
                                                    </div>

                                                </Col>
                                                <Col span={18}>
                                                    <div
                                                        style={{
                                                            margin: "2px",
                                                            padding: "2px",
                                                        }}
                                                    >
                                                        {/* ____________________________________START __________FORMAT________________TEMPLATE___________________*/}

                                                        {/* _______Row No 1________ */}
                                                        <Row style={{ background: "#000000" }}>
                                                            <Col style={{ width: "33%" }}>
                                                                <div
                                                                    style={{
                                                                        borderRadius: "10px",
                                                                        background: "#191C24",
                                                                        border: "1px solid #3c3e4f",
                                                                        margin: "2px 2px 2px 2px",
                                                                    }}
                                                                >
                                                                    <AngelaIconMultiR1C
                                                                        divId={`Production-${index}`}
                                                                        data={chart.Production.data}
                                                                        config={chart.Production.config}
                                                                        onChange={(data) => { }
                                                                        }
                                                                    />
                                                                </div>
                                                            </Col>

                                                            <Col style={{ width: "33%" }}>
                                                                <div
                                                                    style={{
                                                                        borderRadius: "10px",
                                                                        background: "#191C24",
                                                                        border: "1px solid #3c3e4f",
                                                                        margin: "2px 2px 2px 2px",
                                                                    }}
                                                                >
                                                                    <AngelaIconMultiR1C
                                                                        divId={`InputManHrs-${index}`}
                                                                        data={chart.InputManHrs.data}
                                                                        config={chart.InputManHrs.config}
                                                                        onChange={(data) => { }
                                                                        }
                                                                    />
                                                                </div>
                                                            </Col>

                                                            <Col style={{ width: "33%" }}>
                                                                <div
                                                                    style={{
                                                                        borderRadius: "10px",
                                                                        background: "#191C24",
                                                                        border: "1px solid #3c3e4f",
                                                                        margin: "2px 2px 2px 2px",
                                                                    }}
                                                                >
                                                                    <AngelaIconMultiR1C
                                                                        divId={`OutputManHr-${index}`}
                                                                        data={chart.OutputManHrs.data}
                                                                        config={chart.OutputManHrs.config}
                                                                        onChange={(data) => { }
                                                                        }
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row style={{ background: "#000000" }}>
                                                            <Col style={{ width: "33%" }}>
                                                                <div
                                                                    style={{
                                                                        borderRadius: "10px",
                                                                        background: "#191C24",
                                                                        border: "1px solid #3c3e4f",
                                                                        margin: "2px 2px 2px 2px",
                                                                    }}
                                                                >
                                                                    <AngelaIconMultiR1C
                                                                        divId={`Manpower-${index}`}
                                                                        data={chart.Manpower.data}
                                                                        config={chart.Manpower.config}
                                                                        onChange={(data) => { }
                                                                        }
                                                                    />
                                                                </div>
                                                            </Col>

                                                            <Col style={{ width: "33%" }}>
                                                                <div
                                                                    style={{
                                                                        borderRadius: "10px",
                                                                        background: "#191C24",
                                                                        border: "1px solid #3c3e4f",
                                                                        margin: "2px 2px 2px 2px",
                                                                    }}
                                                                >
                                                                    <AngelaIconMultiR1C
                                                                        divId={`LineStatus-${index}`}
                                                                        data={chart.LineStatus.data}
                                                                        config={chart.LineStatus.config}
                                                                        onChange={(data) => { }
                                                                        }
                                                                    />
                                                                </div>
                                                            </Col>

                                                            <Col style={{ width: "33%" }}>
                                                                <div
                                                                    style={{
                                                                        borderRadius: "10px",
                                                                        background: "#191C24",
                                                                        border: "1px solid #3c3e4f",
                                                                        margin: "2px 2px 2px 2px",
                                                                    }}
                                                                >
                                                                    <AngelaIconMultiR1C
                                                                        divId={`DownTime-${index}`}
                                                                        data={chart.DownTime.data}
                                                                        config={chart.DownTime.config}
                                                                        onChange={(data) => { }
                                                                        }
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>

                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                ))
                            }
                        </Row>

                    </div>
                ) : (
                    <div className="Loading" style={{ minHeight: "100vh" }}>
                        <Spin indicator={antIcon} />
                    </div>
                )}
            </div>
        </>
    );
}

export default YiplCorpDashboardLatest;